import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function NarrationMaster(props) {
  const [narrations, setNarrations] = useState([]);
  const [srno, setSrno] = useState('');
  const [narration, setNarration] = useState('');
  const [narration1, setNarration1] = useState('');
  
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editNarrationId, setEditNarrationId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [narrationMasterEntries, setNarrationMasterEntries] = useState([]);

  useEffect(() => {
    fetchNarrationMaster();
  }, []);

  const fetchNarrationMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/narrations');
      setNarrationMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setSrno(nextEntryNo);
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
  let maxEntryNo = 0;
  for (const entry of entries) {
  if (entry.Srno > maxEntryNo) {
  maxEntryNo = entry.Srno;
  }
  }
  return maxEntryNo;
  };

  const addNarration = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/narrations', {
        Srno: srno,
        Narration: narration,
        Narration1: narration1,
        USERID: props.name
      });
      fetchNarrationMaster();
      setSrno('');
      setNarration('');
      setNarration1('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateNarration = async (Srno) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/narrations/${Srno}`, {
        Srno: srno,
        Narration: narration,
        Narration1: narration1,
        USERID: props.name
      });
      fetchNarrationMaster();
      setSrno('');
      setNarration('');
      setNarration1('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteNarration = async (Srno) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/narrations/${Srno}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchNarrationMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };  

  const setEditForm = (narration) => {
    setFormMode('edit');
    setSrno(narration.Srno);
    setNarration(narration.Narration);
    setNarration1(narration.Narration1);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = narrations.filter((narration) => {
      const Srno = narration.Srno.toString().toLowerCase();
      const Narration = narration.Narration.toString().toLowerCase();
      const Narration1 = narration.Narration1.toString().toLowerCase();

      return (
        Srno.includes(searchQuery.toLowerCase()) ||
        Narration.includes(searchQuery.toLowerCase()) ||
        Narration1.includes(searchQuery.toLowerCase())
      );
    });

    setNarrationMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, narrations]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setNarrations(narrations);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditNarrationId('');
    setSrno('');
    setNarration('');
    setNarration1('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "NarrationData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>NarrationMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Srno" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>Srno</label>
            <input
              type="text"
              value={srno}
              readOnly
              placeholder="Srno"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Narration" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>Narration</label>
            <input
              type="text"
              value={narration}
              onChange={(e) => setNarration(e.target.value)}
              placeholder="Narration"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Narration1" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>Narration1</label>
            <input
              type="text"
              value={narration1}
              onChange={(e) => setNarration1(e.target.value)}
              placeholder="Narration1"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addNarration : () => updateNarration(srno)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </> 
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Srno
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Narration
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Narration1
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {narrationMasterEntries.map((narration) => (
                <tr key={narration.Srno} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{narration.Srno}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{narration.Narration}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{narration.Narration1}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(narration)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteNarration(narration.Srno)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default NarrationMaster;

